<form *ngIf="product" [formGroup]="addToCartForm">
  <!--- -------------------------------------------------------------- -->
  <!--- ----------------------PLP LIST VIEW SECTION - START ---------- -->
  <!--- -------------------------------------------------------------- -->

  <div *ngIf="view == 'list'" class="row no-bdr">
    <div
      class="quantity col-6"
      *ngIf="
        (product.sellabilityFlag || product.quotabilityFlag || loggedIn) &&
        showQuantity
      "
    >
      <div
        *ngIf="!product.obsoleteProductFlag"
        class="d-flex align-items-center"
      >
        <label class="quantity-label">{{
          'addCart.quantity' | cxTranslate
        }}</label>

        <cx-item-counter
          [max]="9999"
          [control]="addToCartForm.get('quantity')"
        ></cx-item-counter>

        <span class="eachText">{{ product.salesUnit }}</span>
      </div>
    </div>

    <div *ngIf="loggedIn" class="col-6">
      <button
        *ngIf="
          !product?.hidePrice &&
          product.price?.value &&
          !product?.obsoleteProductFlag &&
          product?.sellabilityFlag
        "
        class="vs-primary-btn mt-0"
        (click)="openCRDdialog('buy')"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
      >
        <span class="material-icons"> add_shopping_cart </span>
        {{ 'addCart.buyBtn' | cxTranslate }}
      </button>
      <!-- CHECKPRICE CUSTOMIZATION 1-------------------- START -->
      <button
        *ngIf="
          hideProductPrice ||
          (!product?.price?.value === undefined &&
            !product.obsoleteProductFlag) ||
          (product.price === undefined &&
            !product.obsoleteProductFlag &&
            checkPriceProduct[product.code] === undefined &&
            !(product.obsoleteProductFlag && product.replacementProductUrl) &&
            (product.sellabilityFlag || product.quotabilityFlag))
        "
        class="vs-tertiary-btn mt-0"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
        (click)="checkPrice(product)"
      >
        <span>{{ 'addCart.checkPriceBtn' | cxTranslate }}</span>
        <div
          *ngIf="displaySearchLoader"
          class="availability-spinner cx-spinner"
        >
          <cx-spinner></cx-spinner>
        </div>
      </button>

      <button
        *ngIf="
          sellabilityAfterPriceCheck &&
          product?.sellabilityFlag &&
          ((!product?.price?.value === undefined &&
            !product.obsoleteProductFlag) ||
            (product.price === undefined &&
              !product.obsoleteProductFlag &&
              checkPriceProduct[product.code] !== undefined &&
              checkPriceProduct[product.code].price !== undefined &&
              checkPriceProduct[product.code].price.value > 0 &&
              checkPriceProduct[product.code].status === 'BUY' &&
              product?.sellabilityFlag) ||
            sellabilityAfterPriceCheck)
        "
        (click)="openCRDdialog('buy')"
        class="vs-primary-btn small-size mt-0"
      >
        <span class="material-icons"> add_shopping_cart </span>
        {{ 'addCart.buyBtn' | cxTranslate }}
      </button>

      <button
        *ngIf="
          !product?.hidePrice &&
          product?.quotabilityFlag &&
          ((!product?.price?.value === undefined &&
            !product.obsoleteProductFlag) ||
            (product?.price?.value === undefined &&
              !product.obsoleteProductFlag &&
              checkPriceProduct[product.code] === undefined &&
              !product?.sellabilityFlag))
        "
        class="vs-tertiary-btn mt-0"
        (click)="openCRDdialog('quote')"
      >
        <span class="material-icons"> receipt </span>
        {{ 'addCart.getQuoteBtn' | cxTranslate }}
      </button>

      <button
        *ngIf="
          product?.quotabilityFlag &&
          !this.hideProductPrice &&
          checkPriceProduct[product.code] !== undefined &&
          (checkPriceProduct[product.code].status === 'QUOTE' ||
            checkPriceProduct[product.code].price.value === 0)
        "
        class="vs-tertiary-btn mt-0"
        (click)="openCRDdialog('quote')"
      >
        <span class="material-icons"> receipt </span>
        {{ 'addCart.getQuoteBtn' | cxTranslate }}
      </button>
      <!-- <span *ngIf="product.displayAlternativetext" class="alternative_list"
        ><em class="material-icons">warning</em>
        <span class="text">
          {{ "addCart.purchaseAvailable" | cxTranslate }}</span
        >
      </span> -->
      <!-- CHECKPRICE CUSTOMIZATION 1-------------------- END -->
      <button
        *ngIf="
          product?.quotabilityFlag &&
          !product?.hidePrice &&
          !(
            product?.price?.value > 0 &&
            !product.obsoleteProductFlag &&
            product?.sellabilityFlag
          ) &&
          product?.price &&
          product?.price?.value !== undefined &&
          product?.price?.value !== null &&
          !(product.obsoleteProductFlag && product.replacementProductUrl)
        "
        class="vs-tertiary-btn mt-0"
        (click)="openCRDdialog('quote')"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
      >
        <span class="material-icons"> receipt </span>

        {{ 'addCart.getQuoteBtn' | cxTranslate }}
      </button>
      <span *ngIf="product.displayAlternativetext" class="alternative_list"
        ><i class="material-icons">warning</i>
        <span class="text">
          {{ 'addCart.purchaseAvailable' | cxTranslate }}
        </span>
      </span>
      <button
        class="view_text_list vs-tertiary-btn mt-0"
        *ngIf="product.obsoleteProductFlag && product.replacementProductUrl"
        (click)="navigateToReplacement()"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
      >
        <span class="material-icons"> swap_horiz </span>
        {{ 'addCart.viewReplacementBtn' | cxTranslate }}
      </button>
    </div>

    <div *ngIf="!loggedIn">
      <button
        class="view_text_list vs-tertiary-btn"
        *ngIf="product.obsoleteProductFlag && product.replacementProductUrl"
        (click)="navigateToReplacement()"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
      >
        <span class="material-icons"> swap_horiz </span>
        {{ 'addCart.viewReplacementBtn' | cxTranslate }}
      </button>

      <!-- <button
        *ngIf="
          (!product.obsoleteProductFlag ||
            (product.obsoleteProductFlag && !product.replacementProductUrl)) &&
          !product?.sellabilityFlag
        "
        (click)="getQuote()"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
        class="vs-tertiary-btn mt-0"
      >
        <span class="material-icons"> receipt </span>
        {{ 'addCart.getQuoteBtn' | cxTranslate }}
      </button> -->

      <span *ngIf="product.displayAlternativetext" class="alternative_list"
        ><i class="material-icons">warning</i>
        <span class="text">
          {{ 'addCart.purchaseAvailable' | cxTranslate }}
        </span>
      </span>
    </div>
  </div>
  <!--- -------------------------------------------------------------- -->
  <!--- ----------------------PLP LIST VIEW SECTION - END ------------ -->
  <!--- -------------------------------------------------------------- -->

  <!--- -------------------------------------------------------------- -->
  <!--- --------------------- GRID SECTION - START ------------------- -->
  <!--- -------------------------------------------------------------- -->
  <div *ngIf="view == 'grid'">
    <div
      class="quantity"
      *ngIf="
        (product.sellabilityFlag || product.quotabilityFlag || loggedIn) &&
        showQuantity &&
        !product.displayAlternativetext
      "
      [ngClass]="{ 'mb-0': product.obsoleteProductFlag }"
    >
      <div
        *ngIf="!product.obsoleteProductFlag"
        class="d-flex align-items-center"
      >
        <label class="quantity-label">{{
          'addCart.quantity' | cxTranslate
        }}</label>

        <cx-item-counter
          [max]="9999"
          [control]="addToCartForm.get('quantity')"
        ></cx-item-counter>

        <span class="eachText"> {{ product.salesUnit }}</span>
      </div>
    </div>

    <span *ngIf="product.displayAlternativetext" class="alternative_grid"
      ><i class="material-icons">warning</i>
      <span class="text">
        {{ 'addCart.purchaseAvailable' | cxTranslate }}
      </span>
    </span>

    <div *ngIf="loggedIn">
      <button
        *ngIf="
          !product?.hidePrice &&
          product.price?.value &&
          !product?.obsoleteProductFlag &&
          product?.sellabilityFlag
        "
        class="vs-primary-btn"
        (click)="openCRDdialog('buy')"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
      >
        <span class="material-icons"> add_shopping_cart </span>
        {{ 'addCart.buyBtn' | cxTranslate }}
      </button>
      <!-- CHECKPRICE CUSTOMIZATION - GRID -------------------- START -->
      <button
        *ngIf="
          hideProductPrice ||
          (!product?.price?.value === undefined &&
            !product.obsoleteProductFlag) ||
          (product.price === undefined &&
            !product.obsoleteProductFlag &&
            checkPriceProduct[product.code] === undefined &&
            !(product.obsoleteProductFlag && product.replacementProductUrl) &&
            (product.sellabilityFlag || product.quotabilityFlag))
        "
        class="vs-tertiary-btn"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
        (click)="checkPrice(product)"
      >
        <span>{{ 'addCart.checkPriceBtn' | cxTranslate }}</span>
        <div
          *ngIf="displaySearchLoader"
          class="availability-spinner cx-spinner"
        >
          <cx-spinner></cx-spinner>
        </div>
      </button>

      <button
        *ngIf="
          sellabilityAfterPriceCheck &&
          product?.sellabilityFlag &&
          ((!product?.price?.value === undefined &&
            !product.obsoleteProductFlag) ||
            (product.price === undefined &&
              !product.obsoleteProductFlag &&
              checkPriceProduct[product.code] !== undefined &&
              checkPriceProduct[product.code].price !== undefined &&
              checkPriceProduct[product.code].price.value > 0 &&
              checkPriceProduct[product.code].status === 'BUY' &&
              product?.sellabilityFlag) ||
            sellabilityAfterPriceCheck)
        "
        (click)="openCRDdialog('buy')"
        class="vs-primary-btn small-size"
        [disabled]="disableBuyBtn"
      >
      <div *ngIf="disableBuyBtn" class="availability-spinner cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
        <span class="material-icons"> add_shopping_cart </span>
        {{ 'addCart.buyBtn' | cxTranslate }}
      </button>

      <button
        *ngIf="
          !product?.hidePrice &&
          product?.quotabilityFlag &&
          ((!product?.price?.value === undefined &&
            !product.obsoleteProductFlag) ||
            (product?.price?.value === undefined &&
              !product.obsoleteProductFlag &&
              checkPriceProduct[product.code] === undefined &&
              !product?.sellabilityFlag))
        "
        class="vs-tertiary-btn"
        (click)="openCRDdialog('quote')"
      >
        <span class="material-icons"> receipt </span>
        {{ 'addCart.getQuoteBtn' | cxTranslate }}
      </button>

      <button
        *ngIf=" 
          product?.quotabilityFlag &&
          !this.hideProductPrice &&
          checkPriceProduct[product.code] !== undefined &&
          (checkPriceProduct[product.code].status === 'QUOTE' ||
            checkPriceProduct[product.code].price.value === 0)
        "
        class="vs-tertiary-btn"
        (click)="openCRDdialog('quote')"
      >
        <span class="material-icons"> receipt </span>
        {{ 'addCart.getQuoteBtn' | cxTranslate }}
      </button>
      <!-- CHECKPRICE CUSTOMIZATION - GRID -------------------- END -->

      <button
        *ngIf="
          product?.quotabilityFlag &&
          !product?.hidePrice &&
          !(
            product?.price?.value > 0 &&
            !product.obsoleteProductFlag &&
            product?.sellabilityFlag
          ) &&
          product?.price &&
          product?.price?.value !== undefined &&
          product?.price?.value !== null &&
          !(product.obsoleteProductFlag && product.replacementProductUrl)
        "
        class="vs-tertiary-btn"
        [ngClass]="{
          'obsolete-get-quote-btn':
            product.obsoleteProductFlag && !hideProductPrice,
          'obsolete-no-price-btn':
            product.obsoleteProductFlag && hideProductPrice,
        }"
        (click)="openCRDdialog('quote')"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
      >
        <span class="material-icons"> receipt </span>
        {{ 'addCart.getQuoteBtn' | cxTranslate }}
      </button>

      <!-- Added for P5 material Status 
	   <button
        *ngIf="
           product.hideButton && product?.quotabilityFlag &&
          !product?.hidePrice &&
          !(
            product?.price?.value > 0 &&
            !product.obsoleteProductFlag &&
            !product?.sellabilityFlag
          ) &&
          product?.price &&
          product?.price?.value !== undefined &&
          product?.price?.value !== null &&
          !(product.obsoleteProductFlag && product.replacementProductUrl)
        "
        class="vs-tertiary-btn"
        [ngClass]="{
          'obsolete-get-quote-btn':
            product.obsoleteProductFlag && !hideProductPrice,
          'obsolete-no-price-btn':
            product.obsoleteProductFlag && hideProductPrice
        }"
        (click)="getQuote()"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
      >
        <span class="material-icons"> receipt </span>

        {{ "addCart.getQuoteBtn" | cxTranslate }}
      </button>-->

      <button
        class="vs-tertiary-btn view_text_list"
        *ngIf="product.obsoleteProductFlag && product.replacementProductUrl"
        (click)="navigateToReplacement()"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
      >
        <span class="material-icons"> swap_horiz </span>
        {{ 'addCart.viewReplacementBtn' | cxTranslate }}
      </button>
    </div>

    <div
      *ngIf="!loggedIn"
      [ngClass]="{ 'action-inverse-margin': product.obsoleteProductFlag }"
    >
      <button
        *ngIf="product.obsoleteProductFlag && product.replacementProductUrl"
        (click)="navigateToReplacement()"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
        class="vs-tertiary-btn"
      >
        <span class="material-icons"> swap_horiz </span>
        {{ 'addCart.viewReplacementBtn' | cxTranslate }}
      </button>

      <!-- <button
        *ngIf="
          (!product.obsoleteProductFlag ||
            (product.obsoleteProductFlag && !product.replacementProductUrl)) &&
          !product?.sellabilityFlag
        "
        (click)="getQuote()"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
        class="vs-tertiary-btn"
      >
        <span class="material-icons"> receipt </span>
        {{ 'addCart.getQuoteBtn' | cxTranslate }}
      </button> -->
    </div>
  </div>

  <!--- -------------------------------------------------------------- -->
  <!--- --------------------- GRID SECTION - END --------------------- -->
  <!--- -------------------------------------------------------------- -->

  <!--- -------------------------------------------------------------- -->
  <!--- ---------------------- PDP SECTION - START ------------------- -->
  <!--- -------------------------------------------------------------- -->
  <div *ngIf="view == 'pdp'">
    <div
      class="quantity quantity-pdp"
      *ngIf="
        showQuantity &&
        (product.sellabilityFlag || product.quotabilityFlag || loggedIn)
      "
    >
      <div class="d-flex align-items-center">
        <label class="quantity-label">{{
          'addCart.quantity' | cxTranslate
        }}</label>

        <cx-item-counter
          [max]="9999"
          (itemCounter)="getCount($event)"
          [control]="addToCartForm.get('quantity')"
        ></cx-item-counter>

        <span class="eachText"> {{ product.salesUnit }}</span>
      </div>
    </div>
    <div
      class="available-at mt-4"
      *ngIf="
        (product.sellabilityFlag || product.quotabilityFlag) &&
        !product.obsoleteProductFlag &&
        userType == 'current'
      "
    >
      <div class="small-font">{{ 'addCart.reqShipDate' | cxTranslate }} <span class="required-field">*</span> </div>
      <vs-date-picker
        *ngIf="renderDatePicker"
        class="date-picker-PDP"
        (selectedDate)="dateChange($event)"
        [defaultDate]="committedDate"
        [filterWeekend]="filterWeekend"
        [min]="minDate"
        [selectedEntity]="selectedLegalEntityId"
      >
      </vs-date-picker>
      <!-- [disabled]="!legalEntityData" -->
      
      <div class="row mt-15" [ngClass]="{ 'mt-bottom-15': showAvailability }">
        <div class="col-8">
          <div class="small-font" *ngIf="product?.plantAvailableAt?.length">
            {{ 'addCart.shippedFrom' | cxTranslate }}
          </div>
          <ng-select
            [searchable]="false"
            [clearable]="false"
            class="available-At"
            placeholder="{{ 'addCart.selectPlaceholder' | cxTranslate }}"
            *ngIf="product?.plantAvailableAt?.length"
            formControlName="availableAt"
            (change)="changeLegalEntity($event)"
          >
            <ng-option
              [value]="availableAddress"
              *ngFor="let availableAddress of shippedFrmOptions"
            >
              {{ availableAddress?.name }} ({{
                availableAddress?.stockAvailable | number: '1.0-0'
              }})
            </ng-option>
          </ng-select>
          <label
            *ngIf="showDiffPlantWarning"
            class="different-plant-warning mt-1"
          >
            <i class="material-icons mr-2">info</i>
            <span class="small-font">
              {{ 'addCart.shippingMsg' | cxTranslate }}
            </span>
          </label>
          <label
            *ngIf="showNotAvailableMsg && product?.plantAvailableAt?.length"
            class="not-available-warning mt-1"
          >
            <i class="material-icons mr-2">info</i>
            <span class="small-font">
              {{ 'addCart.productNotAvailable' | cxTranslate }}
            </span>
          </label>
          <label
            *ngIf="!product?.plantAvailableAt?.length"
            class="not-available-warning mt-1"
          >
            <i class="material-icons mr-2">info</i>
            <span class="small-font">{{
              'addCart.productNotAvailableInAny' | cxTranslate
            }}</span>
          </label>
        </div>
        <div class="col-4" *ngIf="showAvailability === true">
          <button
            class="vs-tertiary-btn check-availability"
            (click)="checkAvailabilityCall(false)"
          >
            {{ 'addCart.checkAvailability' | cxTranslate }}
          </button>
        </div>
      </div>
      <div>
        <div
          class="small-font mt-15"
          *ngIf="showAvailability === false && availabilityDetails.length > 0"
        >
          {{ 'addCart.availabilityInfo' | cxTranslate }}
          <div
            *ngFor="
              let availabilityStatus of availabilityDetails;
              let i = index
            "
            class="availability-information"
          >
            <div
              *ngIf="
                availabilityStatus?.committedDate <= product?.committedDate
              "
            >
              {{ 'addCart.quantityAvailable' | cxTranslate }}
              {{ availabilityStatus.committedQuantity | number: '1.0-0' }}
            </div>
            <div
              *ngIf="
                availabilityStatus?.committedDate > product?.committedDate
              "
              class="bold"
            >
              {{ 'addCart.noStock' | cxTranslate }}
              {{ product?.committedDate | date: 'dd MMMM yyyy' }}
            </div>
            <div
              *ngIf="(availabilityStatus?.committedDate > product?.committedDate) && (product?.materialAvailability == 'Y')"
            >
              {{ 'addCart.earliestShpDate' | cxTranslate }}
              {{ availabilityStatus?.committedQuantity | number: '1.0-0' }} is
              {{ availabilityStatus?.committedDate | date: 'dd MMMM yyyy' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="loggedIn" class="row pdp-gap">
      <button
        *ngIf="
          !product.hideButton &&
          product.price?.value > 0 &&
          !product?.obsoleteProductFlag &&
          product?.sellabilityFlag
        "
        class="vs-primary-btn col-md-4"
        (click)="addToCart()"
        [disabled]="
          disableBuyBtn ||
          quantity <= 0 ||
          quantity > maxQuantity ||
          showAvailability ||
          !committedDate"
      >
        <div *ngIf="disableBuyBtn" class="availability-spinner cx-spinner">
          <cx-spinner></cx-spinner>
        </div>
        <span class="material-icons"> add_shopping_cart </span>

        {{ 'addCart.buyBtn' | cxTranslate }}
      </button>

      <div
        class="col-md-1 pdpquote"
        *ngIf="
          product.price?.value > 0 &&
          !product?.obsoleteProductFlag &&
          product?.sellabilityFlag
        "
      ></div>
      <button
        *ngIf="
          product?.quotabilityFlag &&
          ((product.obsoleteProductFlag && !product.replacementProductUrl) ||
            product?.price?.value === 0 ||
            product)
        "
        class="vs-tertiary-btn col-md-4"
        (click)="getQuote()"
        [disabled]="quantity <= 0 || quantity > maxQuantity || !committedDate"
      >
        <span class="material-icons"> receipt </span>

        {{ 'addCart.getQuoteBtn' | cxTranslate }}
      </button>
      <span *ngIf="product.displayAlternativetext" class="alternative"
        ><i class="material-icons">warning</i>
        <span class="text">
          {{ 'addCart.purchaseAvailable' | cxTranslate }}
        </span>
      </span>
    </div>

    <div class="row">
      <div class="col-md-12 tariff-verbiage-div">
        <span>
          This <b>item</b> is subject to adjustment in the event that new tariffs are implemented, existing tariffs are
          increased, or in case of any increase to the costs of materials or other costs that would affect Baker Hughes’ costs
          or its supply chain, whether directly or indirectly. Baker Hughes reserves the right to adjust pricing to reflect cost
          impacts. Baker Hughes will provide notification of any increase.
        </span>
      </div>
    </div>

    <div *ngIf="!loggedIn" class="row pdp-gap">
      <!-- <button
        *ngIf="
          !product.obsoleteProductFlag ||
          (product.obsoleteProductFlag && !product.replacementProductUrl) ||
          product
        "
        (click)="getQuote()"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
        class="vs-tertiary-btn col-md-4"
      >
        <span class="material-icons"> receipt </span>

        {{ 'addCart.getQuoteBtn' | cxTranslate }}
      </button> -->
      <span *ngIf="product.displayAlternativetext" class="alternative"
        ><i class="material-icons">warning</i>
        <span class="text">
          {{ 'addCart.purchaseAvailable' | cxTranslate }}</span
        >
      </span>
    </div>
  </div>

  <!--- -------------------------------------------------------------- -->
  <!--- ---------------------- PDP SECTION - END --------------------- -->
  <!--- -------------------------------------------------------------- -->

  <!--- ----------------------------------------------------------------------- -->
  <!--- ---------------------- PNA Widget SECTION - START --------------------- -->
  <!--- ----------------------------------------------------------------------- -->

  <div *ngIf="view == 'pnaWidget'">
    <div *ngIf="loggedIn" class="row pdp-gap">
      <button
        *ngIf="
          (product.obsoleteProductFlag && !product.replacementProductUrl) ||
          product?.price?.value === 0 ||
          product
        "
        class="vs-text-btn"
        (click)="getQuote()"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
      >
        <!-- <span class="material-icons"> receipt </span> -->

        {{ 'addCart.raiseQuoteBtn' | cxTranslate }}
      </button>

      <button
        *ngIf="
          !product.hideButton &&
          product.price?.value > 0 &&
          !product?.obsoleteProductFlag &&
          (userRoles.buyer || userRoles.superUser) &&
          product?.sellabilityFlag
        "
        class="vs-primary-btn"
        (click)="addToCart()"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
      >
        <!-- <span class="material-icons"> add_shopping_cart </span> -->

        {{ 'addCart.addToCartBtn' | cxTranslate }}
      </button>
      <div
        class="col-md-1"
        *ngIf="
          product.price?.value > 0 &&
          !product?.obsoleteProductFlag &&
          (userRoles.buyer || userRoles.superUser) &&
          product?.sellabilityFlag
        "
      ></div>
      <button
        *ngIf="
          (product?.price?.value === undefined &&
            !product.obsoleteProductFlag) ||
          (product.price === undefined && !product.obsoleteProductFlag)
        "
        class="vs-tertiary-btn"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
      >
        {{ 'addCart.checkPriceBtn' | cxTranslate }}
      </button>
      <div
        class="col-md-1"
        *ngIf="
          (product?.price?.value === undefined &&
            !product.obsoleteProductFlag) ||
          (product.price === undefined && !product.obsoleteProductFlag)
        "
      ></div>

      <span *ngIf="product.displayAlternativetext" class="alternative"
        ><i class="material-icons">warning</i>
        <span class="text">
          {{ 'addCart.purchaseAvailable' | cxTranslate }}</span
        >
      </span>
    </div>

    <div *ngIf="!loggedIn" class="row pdp-gap">
      <button
        *ngIf="
          !product.obsoleteProductFlag ||
          (product.obsoleteProductFlag && !product.replacementProductUrl) ||
          product
        "
        (click)="getQuote()"
        [disabled]="quantity <= 0 || quantity > maxQuantity"
        class="vs-tertiary-btn col-md-4"
      >
        <span class="material-icons"> receipt </span>

        {{ 'addCart.getQuoteBtn' | cxTranslate }}
      </button>
      <span *ngIf="product.displayAlternativetext" class="alternative"
        ><i class="material-icons">warning</i>
        <span class="text">
          {{ 'addCart.purchaseAvailable' | cxTranslate }}</span
        >
      </span>
    </div>
  </div>

  <div class="checkprice-av" *ngIf="view == 'pdp' && otherInventoryLocations.length > 0">
    <div class="tabletext">
      <table class="table-pdptable">
        <thead>
          <tr class="table-pdp">
            <th>{{ 'addCart.otherLocations' | cxTranslate }}</th>
            <th>{{ 'addCart.noOfUnitsAvailable' | cxTranslate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let entity of otherInventoryLocations"
            class="tbaletrcheck"
          >
            <td>{{ entity.name }}</td>
            <td *ngIf="(product?.materialAvailability == 'Y')">{{ entity?.stockAvailable || 0 | number: '1.0-0' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="buycheckpdp">
      <p class="pdp-checkprice">{{ 'addCart.wantToBuy' | cxTranslate }}</p>
    </div>
    <div class="row buycheckpdp">
      <div class="cx-dialog-info col-md-5">
        <div class="inventory-text">
          <span>{{ 'addCart.topRightPara' | cxTranslate }}</span>
        </div>
      </div>
      <div class="col-md-2">
        <div><img src="../../../../../assets/img/orImg.svg" alt="OR" /></div>
      </div>
      <div class="cx-dialog-info col-md-5 pl-0">
        <div class="inventory-text">
          <span>{{ 'addCart.placeOrderPara' | cxTranslate }}</span>
        </div>
      </div>
    </div>
  </div>
  <!--- ----------------------------------------------------------------------- -->
  <!--- ---------------------- PNA Widget SECTION - START --------------------- -->
  <!--- ----------------------------------------------------------------------- -->
</form>
